import { useEffect, useState } from 'react';
import axios from 'axios';

let cached = null;
// Green IA availability flag (settings_flags.green_ia_enabled) — false after a divestiture
export const useGreenIAStatus = () => {
  const [status, setStatus] = useState(cached || { enabled: true });
  useEffect(() => {
    let alive = true;
    axios.get('/api/green-ia/status').then((r) => { cached = r.data; if (alive) setStatus(r.data); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return status;
};
export const refreshGreenIAStatus = () => { cached = null; };
export default useGreenIAStatus;
